import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { documentsNode } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { ClaimGuard } from '@lsq-frontend/common-ui';
import { Routes } from '@lsq-frontend/common-ui';
import { ViewDocumentsComponent } from './documents.component';

export const documentsRoutes: Routes = [
    {
        path: UiRoutes.Home,
        component: ViewDocumentsComponent,
        canActivate: [ClaimGuard],
        data: {
            title: documentsNode.title,
            claims: documentsNode.claims
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(documentsRoutes)],
    exports: [RouterModule]
})
export class DocumentsRoutingModule {}
